const applications = {
    page_title: '全部应用',
    title: '全部应用',
    subtitle: '创建一个移动、单页、machine-to-machine 或传统 web 应用程序，并通过 Logto 进行身份验证',
    subtitle_with_app_type: '为你的 {{name}} 应用程序设置 Logto 身份验证',
    create_device_flow_description: '创建一个使用 OAuth 2.0 设备授权许可的原生应用，适用于输入受限设备或无头应用。',
    create: '创建应用',
    create_third_party: '创建第三方应用',
    create_thrid_party_modal_title: '创建第三方应用（{{type}}）',
    application_name: '应用名称',
    application_name_placeholder: '我的应用',
    application_description: '应用描述',
    application_description_placeholder: '请输入应用描述',
    select_application_type: '选择应用类型',
    no_application_type_selected: '你还没有选择应用类型',
    application_created: '创建应用成功。',
    tab: {
        my_applications: '我的应用',
        third_party_applications: '第三方应用',
    },
    app_id: 'App ID',
    type: {
        native: {
            title: '原生应用',
            subtitle: '在原生环境中运行的应用程序',
            description: '例如 iOS 应用程序、Android 应用程序、桌面应用程序、电视、CLI',
        },
        spa: {
            title: '单页应用',
            subtitle: '在浏览器中运行并动态更新数据的应用程序',
            description: '例如 React DOM 应用程序，Vue 应用程序',
        },
        traditional: {
            title: '传统网页应用',
            subtitle: '仅由 Web 服务器渲染和更新的应用程序',
            description: '例如 Next.js, PHP',
        },
        machine_to_machine: {
            title: '机器对机器',
            subtitle: '直接与资源对话的应用程序（通常是服务）',
            description: '例如后端服务',
        },
        protected: {
            title: '受保护的应用',
            subtitle: '受 Logto 保护的应用程序',
            description: 'N/A',
        },
        saml: {
            title: 'SAML 应用',
            subtitle: '用作 SAML IdP 连接器的应用程序',
            description: '例如，SAML',
        },
        third_party: {
            title: '第三方应用',
            subtitle: '用作第三方 IdP 连接器的应用程序',
            description: '例如，OIDC，SAML',
        },
    },
    authorization_flow: {
        title: '授权流程',
        tooltip: '选择应用的授权流程。一旦设置，将无法更改。',
        authorization_code: {
            title: 'Authorization code',
            description: '默认且最常见的授权类型。用户将被重定向到登录页面以直接授权访问。',
        },
        device_flow: {
            title: 'Device flow',
            description: '适用于输入受限的设备或无界面应用（如电视、CLI）。用户在另一台设备上通过输入设备码或扫描二维码完成登录。',
        },
    },
    placeholder_title: '选择应用程序类型以继续',
    placeholder_description: 'Logto 使用 OIDC 的应用程序实体来帮助识别你的应用程序、管理登录和创建审计日志等任务。',
    third_party_application_placeholder_description: '使用 Logto 作为身份提供者为第三方服务提供 OAuth 授权。\n 包括资源访问的预建用户同意屏幕。<a>了解更多</a>',
    dynamic_app: {
        title: '动态应用',
        subtitle: 'CIMD',
        description: '动态应用允许 OAuth 客户端无需预先注册即可接入。',
        settings_description: '动态应用允许 OAuth 客户端无需预先注册即可接入，基于 OAuth Client ID Metadata Document (CIMD) 规范。',
        app_id_placeholder: '由每个客户端动态提供',
        enable_confirm_modal: {
            title: '启用动态客户端接入？',
            content: '任何拥有有效公开 HTTPS 客户端 ID URL 的 OAuth 客户端，都可以无需预先注册即向该租户发起授权。访问范围仍受你设置的最大权限和用户同意的限制。',
        },
        enabled: '动态应用已成功启用。',
        disable_confirm_modal: {
            title: '禁用动态应用？',
            content: 'CIMD 客户端将无法再发起新的授权请求。已有的授权记录会保留，已签发的访问令牌在过期前可能仍然有效。',
        },
        disabled: '动态应用已成功禁用。',
        permissions: {
            user_title: '用户',
            user_description: '选择 OAuth 客户端访问特定用户数据所需的权限。',
            grant_user_level_permissions: '授予用户权限',
            organization_title: '组织',
            organization_description: '选择 OAuth 客户端访问特定组织数据所需的权限。',
            grant_organization_level_permissions: '授予组织权限',
            permission_delete_confirm: '此操作将从动态应用中移除该权限，阻止 OAuth 客户端就该权限请求用户授权。你确定要继续吗？',
        },
    },
    guide: {
        third_party: {
            title: '集成第三方应用',
            description: '使用 Logto 作为身份提供者为第三方服务提供 OAuth 授权。包含用于安全资源访问的预建用户同意屏幕。<a>了解更多</a>',
        },
    },
};
export default Object.freeze(applications);
